import type { CaseStudy } from "./types";

const cs: CaseStudy = {
  slug: "nairobi-agritech",
  founder: "Wanjiru Kariuki",
  company: "ShambaConnect",
  city: "Nairobi",
  country: "Kenya",
  pillar: "bootcamp",
  outcomeShort: {
    en: "5,000 farmers onboarded in 4 months",
    fr: "5 000 agriculteurs onboardés en 4 mois",
  },
  title: {
    en: "ShambaConnect onboards 5,000 farmers using a market-validation framework",
    fr: "ShambaConnect onboarde 5 000 agriculteurs avec un cadre de validation marché",
  },
  subtitle: {
    en: "USSD-first product strategy unlocked rural distribution.",
    fr: "Une stratégie produit USSD-first a débloqué la distribution rurale.",
  },
  body: {
    en: {
      context: "Wanjiru's original app required smartphones and 4G. After 8 months only 200 farmers were active and most quit within a week.",
      challenge: "Rural Kenyan farmers had feature phones, intermittent connectivity, and deep distrust of digital tools after years of failed agritech promises.",
      approach: "Through the Product-Market-Fit bootcamp she rebuilt around USSD codes, M-Pesa-native payouts, and field agent referral loops. Tested 11 message variants before scaling.",
      outcome: "5,000 active farmers in 4 months. 73% weekly retention. Closed a partnership with KCB Bank to extend credit through the platform.",
      quote: "The bootcamp killed my app and gave me back my product.",
      quoteAuthor: "Wanjiru Kariuki · Founder, ShambaConnect",
    },
    fr: {
      context: "L'app originale de Wanjiru exigeait smartphone et 4G. Après 8 mois, seuls 200 agriculteurs étaient actifs et la plupart abandonnaient en une semaine.",
      challenge: "Les agriculteurs ruraux kényans avaient des feature phones, une connectivité intermittente, et une méfiance profonde envers les outils digitaux après des années de promesses agritech ratées.",
      approach: "Via le bootcamp Product-Market-Fit elle a tout reconstruit autour de codes USSD, payouts M-Pesa natifs et boucles de parrainage par agents terrain. 11 variantes de messages testées avant scaling.",
      outcome: "5 000 agriculteurs actifs en 4 mois. 73 % de rétention hebdo. Partenariat signé avec KCB Bank pour étendre du crédit via la plateforme.",
      quote: "Le bootcamp a tué mon app et m'a rendu mon produit.",
      quoteAuthor: "Wanjiru Kariuki · Fondatrice, ShambaConnect",
    },
  },
  relatedBootcampSlug: "product-market-fit",
};
export default cs;
